export default "__VITE_ASSET___2h82aNk__"